import { FilterIcon } from "../../../assets/imgs";
import Modal from "../../../components/Modal/Modal";
import { Form, Field, Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { useStore } from "../../../store/useStore";
import { useEffect } from "react";
import CustomDatePicker from "../../../components/FormComponents/CustomDateTimePicker/CustomDateTimePicker";
import { INFRACTION_TYPES } from "../../../utils/constants/constants";
import Checkbox from "../../../components/FormComponents/Checkbox/Checkbox";
import OutlinedButton from "../../../components/OutlinedButton/OutlinedButton";
import FilledButton from "../../../components/FilledButton/FilledButton";

const initialValues = {
  start_date: "",
  end_date: "",
  reference_month: "",
  infraction_types: {
    ...INFRACTION_TYPES.map((infraction_type) => ({ [infraction_type.value]: true })).reduce((acc, curr) => ({ ...acc, ...curr }), {})
  } as Record<string, any>,
};

const FilterInfractionModal: React.FC<{}> = () => {
  const setFilters = useStore((state) => state.infraction.infractionRankingList.setFilters);
  const filters = useStore((state) => state.infraction.infractionRankingList.filters);
  const clearFilter = (formik: FormikProps<typeof initialValues>) => { formik.resetForm() };
  return (
    <Modal
      title="Filtros de infrações"
      icon={<FilterIcon width={30} height={30} />}
      className="w-[447px]"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={Yup.object().shape({
          competence: Yup.string(),
          day: Yup.string(),
          types: Yup.string()
        })}
        onSubmit={(values) => {
          setFilters({
            ...values,
            infraction_types: Object.keys(values.infraction_types).filter((key) => values.infraction_types[key])
          });
        }}
      >
        {(formik) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (filters) {
              const infraction_types = filters.infraction_types?.map((infraction_type) => ({ [infraction_type]: true })).reduce((acc, curr) => ({ ...acc, ...curr }), {}) ?? {};
              formik.setValues({
                ...filters,
                infraction_types
              });
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
          }, [filters]);

          return (
            <Form>
              <div>
                <div className="text-dark-blue font-semibold text-md my-4">
                  Tipo de Infração
                </div>
                <div className="flex flex-wrap items-start">
                {
                  INFRACTION_TYPES.map((infraction_type: any) => {
                    return (
                      <div className="bg-gray_0 p-1 rounded-[7px] mr-2 mb-2">
                        <Checkbox
                          key={infraction_type.value}
                          onChange={() => {
                            const infractionTypes = Object.entries(formik.values.infraction_types).map(([key, value]) => value ? key : null).filter(e => e);
                            if(infractionTypes?.length === 1 && infractionTypes[0] === infraction_type.value) return;
                            formik.setFieldValue(
                              `infraction_types.${infraction_type.value}`,
                              !formik.values['infraction_types'][infraction_type.value]
                            )
                          }}
                          className="w-[17px] h-[17px]"
                          labelClassName="font-light font-base text-lg"
                          checked={formik.values?.infraction_types?.[infraction_type.value] ?? false}
                          text={infraction_type.label}
                        />
                      </div>
                    )
                  })
                }
                </div>
                <div className="flex gap-5 mt-5">
                  <div className="flex-1">
                    <OutlinedButton
                      onClick={() => {
                        clearFilter(formik);
                      }}
                      className="w-full"
                      type="button"
                    >
                      Limpar Filtros
                    </OutlinedButton>
                  </div>
                  <div className="flex-1">
                    <FilledButton className="w-full" type="submit">
                      Filtrar
                    </FilledButton>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default FilterInfractionModal;
